import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import ScanResults from "../../ScanResults";
import Step1 from "./Step1";

const LeadCreaseTemplate = (props: any) => {
  const navigate = useNavigate();
  const {
    vendor,
    activeTab,
    formFields,
    handleStep2,
    createAndDownloadPdf,
    reportId,
  } = props;

  return (
    <>
      <div className="leadcrease">
        <Container fluid className="bg-white">
          <Row>
            <Col className="lead-crease-header">
              <img
                src="/images/lead-crease-logo.png"
                alt="Lead Crease Logo"
                className="lead-crease-logo img-fluid"
                onClick={(e) => navigate("/home")}
              />
            </Col>
          </Row>
        </Container>
        <div className="lead-crease">
          {(activeTab === 1 || activeTab === 2) && (
            <Step1
              vendor={vendor}
              formFields={formFields}
              onSubmit={handleStep2}
            />
          )}

          {activeTab === 3 && (
            <ScanResults
              vendor={vendor}
              createAndDownloadPdf={createAndDownloadPdf}
              reportId={reportId}
            />
          )}

          <footer className="leadcreast-footer">
            <Container fluid>
              <Row>
                <Col className="lead-crease-header">
                  <img
                    src="/images/lead-crease-logo.png"
                    alt="Lead Crease Logo"
                    className="lead-crease-logo img-fluid"
                    onClick={(e) => navigate("/home")}
                  />
                </Col>
              </Row>
            </Container>
          </footer>
        </div>
      </div>
    </>
  );
};

export default LeadCreaseTemplate;
